import { takeLatest, call, put } from 'redux-saga/effects';
import request from '../../utils/request';
import API from '../../config/api';
import { setUser, submitUserFail, submitUserSuccess } from './actions';
import login from '../../services/login';
import { GET_USER, SUBMIT_USER, RESTORE_USER } from './constants';

function* submitUser({ user }) {
	try {
		const url = `${API()}/action/updatePersonV2`;
		const options = {
			url,
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			params: {
				ajax: true,
			},
			data: {
				...user,
				ajax: true,
			},
		};
		yield call(request, options);
		yield put(submitUserSuccess(user));
		yield put(setUser(user));
	} catch (error) {
		console.warn(error);
		yield put(submitUserFail());
	}
}

function* restoreUser() {
	try {
		const user = yield call(login.getUser);
		yield put(setUser(user, false));
	} catch (error) {
		console.warn(error);
	}
}

function* getUser() {
	try {
		const url = `${API()}/action/getPerson`;
		const options = {
			url,
			method: 'GET',
		};

		const { data } = yield call(request, options);

		if (typeof (data) === 'string') {
			// yield call(login.logout);
		} else {
			const user = yield call(login.getUser);
			const newUser = { ...user, ...data };
			yield call(login.setUser, newUser);
			yield put(setUser(newUser));
		}
	} catch (err) {
		// yield call(loadLocations, ids, user.addInfo1);
		console.warn(err);
	}
}

export default function* UserProviderSaga() {
	yield takeLatest(GET_USER, getUser);
	yield takeLatest(SUBMIT_USER, submitUser);
	yield takeLatest(RESTORE_USER, restoreUser);
}
